import { render } from "./single-package.vue?vue&type=template&id=626e14a6"
import script from "./single-package.vue?vue&type=script&lang=js"
export * from "./single-package.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__